<template>
  <el-container>
    <!-- <el-aside :style="{ width: isCollapse ? '50px' : '160px' }">
      <div class="logo"
           :style="{ width: isCollapse ? '50px' : '160px' }">
        <i class="iconfont"
           :class="{ collapse: isCollapse }">&#xe616;</i><span v-if="!isCollapse">MetaDream</span>
      </div>
      <div class="aside">
        <el-menu :default-active="getRoute"
                 :collapse-transition="false"
                 background-color="#272727"
                 text-color="#939393"
                 router
                 :default-openeds="openeds"
                 class="el-menu-vertical-demo"
                 :collapse="isCollapse">
          <aside-menu v-for="(item, index) in leftMenuList"
                      :key="index"
                      :obj="item"
                      :currentTopMenu="currentTopMenu" />
        </el-menu>
      </div>
    </el-aside> -->
    <el-aside width="160px"
              class="aside">
      <div class="logo-content">
        <img class="header-logo"
             src="@/assets/logo2.png" />
        <span>君海游戏</span>
      </div>
      <router-view name="navigation" />
    </el-aside>

    <el-container class="content">
      <el-header>
        <el-menu :default-active="myPath"
                 class="header-menu"
                 mode="horizontal"
                 :active="$route.path"
                 router>
          <el-menu-item index="/website">网站管理</el-menu-item>
          <el-menu-item index="/template">模板管理</el-menu-item>
          <!-- <el-menu-item index="/system">系统管理</el-menu-item> -->
        </el-menu>
        <div class="user_name"
             @click="showLoginOut">
          <span class="name">{{ user_name }}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <div :class="{loginOut:true,hiddenBtn:isHidden}"
             @click="signOut()">退出</div>

      </el-header>
      <!--通知条-->
      <div class="wrap"
           id="wrap"
           v-show="msg">
        <div class="cont"
             id="cont">
          <div id="txt"
               class="txt"
               v-html="msg">
          </div>
          <!-- <i class='el-icon-info' ></i> -->
          <div id="txt-copy"
               class="txt"
               v-show="showCopyText">
            <!-- <div class="icon"
                 v-show="showCopyText">!</div>
            &nbsp;&nbsp;&nbsp;&nbsp; -->
            <p v-html="msg"></p>
          </div>
        </div>
      </div>
      <el-main v-loading="loading">
        {{ENV_ONLINE}}
        <router-view />
      </el-main>
    </el-container>
    <!-- <el-footer>
      <p class="content">权限开通请发送邮件至pm@ijunhai.com，抄送给相关业务负责人</p>
      <p class="content">2014©广州君海网络科技有限公司</p>
    </el-footer> -->
  </el-container>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import api from '../api/api';

export default {
  data() {
    return {
      isHidden: true,
      showCopyText: false,
      ENV_ONLINE: '',
      myPath: '',
      scorllTextWidth: 0,
      msg: '',
    };
  },
  mounted() {
    this.myPath = `/${this.$route.path.split('/')[1]}`;
    if (localStorage.getItem('ENV_ONLINE') === 'dev_online') {
      this.ENV_ONLINE = '测试环境（dev_online）';
    }
    this.$store.commit('user_name', localStorage.getItem('user_name'));
  },
  methods: {
    showLoginOut() {
      if (this.isHidden) {
        this.isHidden = false;
      } else {
        this.isHidden = true;
      }
    },
    signOut() {
      this.$confirm('您确定要退出嘛?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        axios.get(`${api.url}logout`).then((response) => {
          if (response.data.ret === 0) {
            this.$message({
              message: '退出成功~',
              type: 'success',
            });
            localStorage.removeItem('token');
            location.href = api.login_web;
          }
        });
      });
    },
  },
  watch: {
    notificationMessage(msg) {
      this.msg = msg;
      this.$nextTick(() => {
        const txtDom = document.getElementById('txt');
        if (txtDom && txtDom.style) {
          this.scorllTextWidth = txtDom.offsetWidth;
        }
        const text = document.getElementById('txt');
        const textCopy = document.getElementById('txt-copy');
        const cont = document.getElementById('cont');
        const wrap = document.getElementById('wrap');
        if (wrap && wrap.offsetWidth > this.scorllTextWidth && textCopy) {
          this.showCopyText = false;
          return;
        }
        if (text && text.style && cont && textCopy && wrap) {
          this.showCopyText = true;
          const dobuleWidth = `${this.scorllTextWidth * 2}px`;
          const width = `${this.scorllTextWidth + 100}px`;
          wrap.style.width = width;
          cont.style.width = dobuleWidth;
          text.style.width = width;
          textCopy.style.width = width;
          document.getElementsByClassName('cont')[0].classList.add('cont-scroll');
        }
      });
    },
  },
  computed: {
    ...mapState([
      'user_name',
      'loading',
      'notificationMessage',
    ]),
  },

};
</script>

<style lang="less" scoped>
.wrap {
  display: flex;
  align-items: center;
  position: relative;
  height: 36px;
  border-radius: 4px;
  background: rgba(230, 162, 60, 0.1);
  overflow: hidden;
  .cont {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    position: absolute;
    left: 0;
    padding-left: 20px;
    // width: 200%;
    &.cont-scroll {
      animation: 30s move infinite linear;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      font-size: 12px;
      color: white;
      background-color: #e6a23c;
    }
    .txt {
      display: flex;
      align-items: center;
      width: auto;
      height: 20px;
      margin-left: 10px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      line-height: 20px;
      color: #e6a23c;
      text-align: left;
      white-space: nowrap;
      margin-right: 30px;
    }
    #txt-copy {
      &.txt-copy-none {
        display: none;
      }
    }
  }
}
.wrap:hover .cont {
  animation-play-state: paused;
}
@keyframes move {
  /* 原理 left值的变化 移动一个容器的宽度 */
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
.el-container {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.el-footer {
  background: #1c1c1c;
  color: #605f5f;
  z-index: 100;
  padding: 5px 0;
  position: fixed;
  width: 100%;
  bottom: 0;
}

.el-header {
  box-shadow: 0px 2px 6px 1px rgba(56, 132, 194, 0.1);
  padding: 0;
  line-height: 50px;
  height: 50px !important;
  color: #303133;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  position: relative;
  .el-menu-item {
    height: 50px;
    line-height: 50px;
    user-select: none;
    color: #303133;
  }
  .el-menu-item.is-active {
    color: #409eff;
  }
  .el-menu--horizontal > .el-menu-item:hover {
    color: #409eff;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    color: #409eff;
  }
  .header-menu {
    display: flex;
    align-items: center;
  }
  .contract-icon {
    flex: none;
    padding: 0 16px;
    cursor: pointer;
    .iconfont {
      color: #606266;
      font-size: 16px;
    }
  }
  .menu-right {
    display: flex;
    .platform-div {
      margin-right: 40px;
    }
    .el-dropdown {
      color: #303133;
      cursor: pointer;
    }
    // 公告记录样式
    .announcement-div {
      margin-right: 40px;
    }
  }
}
.hiddenBtn {
  display: none;
}
.header-menu {
  margin-left: 30px;
}
.el-main {
  overflow: auto;
  height: calc(100vh - 90px);
  padding: 16px;
  box-shadow: 0px 2px 6px 1px rgba(56, 132, 194, 0.1);
}
.logo-content {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  background: #000;
  font-weight: bold;
  color: #fff;
  .header-logo {
    margin: 5px 10px;
    width: auto;
    height: 30px;
  }
}

.header-menu {
  display: block;
  margin-right: 0px;
  width: 100%;
  // background: #B3C0D1;
}

.el-footer {
  text-align: center;
  font-size: 14px;
  display: table;
  align-items: center;
  .content {
    display: table-row;
    text-align: center;
    line-height: 25px;
  }
}

.el-aside {
  color: #303133;
  .el-menu {
    height: ~"calc(100vh - 50px)";
  }
}
.user_name {
  position: absolute;
  right: 40px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #303133;
  font-size: 14px;
  cursor: pointer;
  i {
    margin-left: 10px;
  }
}
.loginOut {
  position: absolute;
  top: 50px;
  right: 50px;
  background-color: #e6e6e6;
  font-size: 14px;
  color: #999;
  width: 60px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border: 1px solid #999;
  border-radius: 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/containers/DefaultContainer.vue